import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

// Create context
export const ProfilePhotoContext = createContext({
  showProfilePhotoDialog: false,
  setShowProfilePhotoDialog: () => {},
  needsProfilePhoto: false,
});

// Create provider component
export const ProfilePhotoProvider = ({ children }) => {
  const [showProfilePhotoDialog, setShowProfilePhotoDialog] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const isAuthenticated = useSelector((state) => Boolean(state.auth.token && state.auth.user?.id));
  const [needsProfilePhoto, setNeedsProfilePhoto] = useState(false);

  // Check if user needs to upload a profile photo
  useEffect(() => {
    if (isAuthenticated && user) {
      const missingProfilePhoto = !user.profile_photo_url;
      setNeedsProfilePhoto(missingProfilePhoto);
      
      // Auto-show the dialog when user logs in without a photo
      if (missingProfilePhoto) {
        setShowProfilePhotoDialog(true);
      }
    } else {
      setNeedsProfilePhoto(false);
      setShowProfilePhotoDialog(false);
    }
  }, [isAuthenticated, user]);

  // Create context value
  const contextValue = {
    showProfilePhotoDialog,
    setShowProfilePhotoDialog,
    needsProfilePhoto,
  };

  return (
    <ProfilePhotoContext.Provider value={contextValue}>
      {children}
    </ProfilePhotoContext.Provider>
  );
};

// Custom hook for using the profile photo context
export const useProfilePhoto = () => useContext(ProfilePhotoContext); 